import content, { format, countLabel } from "../site/content";
import { useState, useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { gitesById, giteName, photos, seaView, money, stayPrice, nightsBetween, today } from '../site/data';
import { Icon, PageTitle, Callout, GitePicture } from '../site/UI';
import Tilt from "./Tilt";
function PhotoGallery({
  gite
}) {
  const images = photos(gite);
  const [index, setIndex] = useState(0);
  const dialog = useRef(null);
  useEffect(() => {
    const element = dialog.current;
    const restore = () => {
      document.body.style.overflow = '';
    };
    element.addEventListener('close', restore);
    return () => {
      restore();
      element.removeEventListener('close', restore);
    };
  }, []);
  const open = i => {
    setIndex(i);
    dialog.current.showModal();
    document.body.style.overflow = 'hidden';
  };
  const move = offset => setIndex(i => (i + offset + images.length) % images.length);
  return <>
    <Tilt className="photo-mosaic" max={4} scale={1.01}>{images.slice(0, 3).map((photo, i) => <button key={photo.original} onClick={() => open(i)} aria-label={format(content.pages.property.gallery.open, {
        index: i + 1,
        name: giteName(gite)
      })}><GitePicture src={photo.original} alt={format(content.pages.property.gallery.alt, {
          name: giteName(gite),
          index: i + 1
        })} /><span className="photo-open"><Icon name="grid" />{i === 2 ? content.pages.property.gallery.all : content.pages.property.gallery.enlarge}</span></button>)}</Tilt>
    <dialog ref={dialog} className="gallery-dialog" aria-label={format(content.pages.property.gallery.title, {
      name: giteName(gite)
    })} onClick={event => {
      if (event.target === event.currentTarget) dialog.current.close();
    }} onKeyDown={event => {
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault();
        move(event.key === 'ArrowRight' ? 1 : -1);
      }
    }}>
      <div className="gallery-toolbar"><span>{giteName(gite)} · {index + 1} / {images.length}</span><button autoFocus aria-label={content.pages.property.gallery.close} onClick={() => dialog.current.close()}><Icon name="close" /></button></div>
      <div className="gallery-stage"><button aria-label={content.pages.property.gallery.previous} onClick={() => move(-1)}><Icon name="left" /></button><GitePicture draggable={false} src={images[index].original} alt={format(content.pages.property.gallery.alt, {
          name: giteName(gite),
          index: index + 1
        })} /><button aria-label={content.pages.property.gallery.next} onClick={() => move(1)}><Icon name="right" /></button></div>
      <div className="gallery-thumbnails">{images.map((photo, i) => <button key={photo.original} onClick={() => setIndex(i)} aria-label={format(content.pages.property.gallery.thumbnail, {
          index: i + 1
        })} aria-pressed={i === index}><GitePicture draggable={false} src={photo.thumbnail} alt="" /></button>)}</div>
    </dialog>
  </>;
}
function AvailabilityCard({
  gite
}) {
  const [start, setStart] = useState('');
  const [end, setEnd] = useState('');
  const [people, setPeople] = useState(content.pricing.defaultGuests);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const nights = nightsBetween(start, end);
  function submit(event) {
    event.preventDefault();
    if (!nights || start < today()) {
      setError(content.pages.property.booking.dateError);
      return;
    }
    navigate('/contact?' + new URLSearchParams({
      gite: gite.initial,
      arrivee: start,
      depart: end,
      personnes: people
    }));
  }
  return <aside className="booking-card"><p className="booking-price">{content.pages.property.booking.from}{" "}<strong>{money(gite.tarif)}</strong>{" "}{content.pages.property.booking.perNight}</p><form onSubmit={submit}><label>{content.common.arrival}<input type="date" required min={today()} value={start} onChange={e => {
          setStart(e.target.value);
          setError('');
        }} /></label><label>{content.common.departure}<input type="date" required min={start || today()} value={end} onChange={e => {
          setEnd(e.target.value);
          setError('');
        }} /></label><label>{content.common.guests}<select aria-label={content.common.guests} value={people} onChange={e => setPeople(Number(e.target.value))}>{Array.from({
            length: gite.maxclient
          }, (_, i) => <option key={i} value={i + 1}>{countLabel('people', i + 1)}</option>)}</select></label>{nights > 0 && <p className="estimate" aria-live="polite">{countLabel('nights', nights)} · <strong>{money(stayPrice(gite, nights, people))}</strong><small>{content.common.estimate}</small></p>}{error && <p role="alert" className="form-error">{error}</p>}<button className="button" type="submit">{content.pages.property.booking.cta}{" "}<Icon name="arrow" /></button><p className="form-note"><Icon name="info" />{content.pages.property.booking.note}</p></form></aside>;
}
export default function PageNosGites({
  initial
}) {
  const gite = gitesById[initial];
  const equipment = gite.presentation.equipements.map(id => content.equipment[id]);
  return <div className="container property-page">
    <PageTitle title={format(content.pages.property.metaTitle, {
      name: giteName(gite)
    })} description={gite.presentation.description} />
    <nav className="breadcrumb" aria-label={content.navigation.breadcrumb}><Link to="/">{content.navigation.home}</Link><span>/</span><Link to="/#nos-gites">{content.navigation.gites}</Link><span>/</span><span>{giteName(gite)}</span></nav>
    <p className="eyebrow">{content.site.location}</p><h1>{giteName(gite)}</h1>
    <span className="location-badge"><Icon name={seaView(gite) ? 'waves' : 'pin'} />{seaView(gite) ? content.common.seaView : content.common.townLocation}</span>
    <PhotoGallery gite={gite} />
    <div className="property-layout"><div className="property-description"><h2>{seaView(gite) ? content.pages.property.seaTitle : content.pages.property.townTitle}</h2><p>{gite.presentation.description}</p><div className="property-facts"><span><Icon name="users" />{countLabel('people', gite.maxclient)}</span><span><Icon name="home" />{countLabel('rooms', gite.presentation.chambres)}</span><span><Icon name="grid" />{format(content.common.area, {
              count: gite.presentation.surface_m2
            })}</span></div><section className="equipment"><h2>{content.pages.property.equipment}</h2><div>{equipment.map(({
              icon,
              label
            }) => <span key={label}><Icon name={icon} />{label}</span>)}</div><details><summary>{content.pages.property.details}</summary><ul>{gite.description.listDescription.map(line => <li key={line}>{line}</li>)}</ul></details></section></div><AvailabilityCard gite={gite} /></div>
    <section className="location-section"><div><p className="eyebrow">{content.pages.property.location.eyebrow}</p><h2>{content.pages.property.location.title}</h2><p>{content.pages.property.location.description}</p><p className="address"><Icon name="pin" />{gite.adresse}</p><a className="text-link" href={gite.lieu} target="_blank" rel="noreferrer">{content.pages.property.location.directions}{" "}<Icon name="arrow" /></a></div><a href={gite.lieu} target="_blank" rel="noreferrer" className="location-map" aria-label={format(content.pages.property.location.label, {
        name: giteName(gite)
      })}><img src={content.media.map.src} alt={content.media.map.alt} loading="lazy" /><span className="photo-badge"><Icon name="pin" />{content.pages.property.location.openMap}</span></a></section>
    <Callout title={content.pages.property.callout} to={'/contact?gite=' + initial} />
  </div>;
}
